import { useGetServerTime } from '@engoo/react-server-time';
import { useEffect, useReducer } from 'react';

/**
 * Forces a component to rerender at a particular interval.
 */
export const useAutoRerender = (refreshRateMs: number): void => {
  const [, forceRefresh] = useReducer(() => Symbol(), Symbol());

  useEffect(() => {
    const timeoutId = setInterval(forceRefresh, refreshRateMs);
    return () => clearInterval(timeoutId);
  }, [refreshRateMs]);
};

/**
 * Gives the current time for components that depend on rendering something
 * based on the current time.
 */
export const useCountdownTick = (): Date => {
  useAutoRerender(100);
  return useGetServerTime()();
};
